<template>
  <form @keyup.enter="save">
    <div>
      <div class="control is-horizontal columns">
        <div class="control-label column is-3 label-create">
          <label class="label">Title</label>
        </div>
        <div class="control is-grouped column is-9">
          <p class="control is-expanded">
            <input
              v-validate="'max:100'"
              :class="{'is-danger': errors.has('title') }"
              name="title"
              v-model="body.title"
              class="input"
              type="text"
              placeholder="Enter title"
            />
            <span
              v-show="errors.has('title')"
              class="help is-danger"
            >{{ errors.first('title') }}</span>
          </p>
        </div>
      </div>
      <div class="control is-horizontal columns">
        <div class="control-label column is-3 label-create">
          <label class="label">Description</label>
        </div>
        <div class="control is-grouped column is-9">
          <p class="control is-expanded">
            <input
              v-validate="'max:255'"
              :class="{'is-danger': errors.has('description') }"
              name="description"
              v-model="body.description"
              class="input"
              type="text"
              placeholder="Enter description"
            />
            <span
              v-show="errors.has('description')"
              class="help is-danger"
            >{{ errors.first('description') }}</span>
          </p>
        </div>
      </div>
      <div class="control is-horizontal columns">
        <div class="control-label column is-3 label-create">
          <label class="label field-required">Slide Image</label>
        </div>
        <div class="control is-grouped column is-9">
          <slider-dropzone
            :data="galleries"
            @input="onGallery"
            @featured="setFeaturedImage"
            :featured="body.image"
          ></slider-dropzone>
          <span class="helper-text">The slide should be 1900 × 570 px</span>
          <span
              v-show="requiredImage"
              class="help is-danger"
            >The Slide Image field is required</span>
        </div>
      </div>
      <div class="control is-horizontal columns">
        <div class="control-label column is-3 label-create">
          <label class="label">Mobile Slide Image</label>
        </div>
        <div class="control is-grouped column is-9">
          <slider-dropzone
            :data="mobileGalleries"
            @input="onMobileGallery"
            @featured="setFeaturedMobileImage"
            :featured="body.mobile_image"
          ></slider-dropzone>
          <span class="helper-text">The mobile slide should be 800 × 860 px</span>
        </div>
      </div>

      <div class="control is-horizonetal columns">
        <div class="control-label column is-3 label-create">
          <label class="label">Slide redirect</label>
        </div>
        <div class="control is-grouped column is-9">
          <p
            class="control is-expanded is-flex"
            style="align-items: center"
          >
            <input
              :class="{'is-danger': errors.has('redirect url') }"
              name="redirect url"
              v-model="body.redirect_url"
              class="input"
              type="text"
              placeholder="Enter slide redirect"
            />
            <span
              v-show="errors.has('redirect url')"
              class="help is-danger"
            >{{ errors.first('redirect url') }}</span>
          </p>
        </div>
      </div>

      <div class="control is-horizonetal columns">
        <div class="control-label column is-3 label-create">
          <label class="label">Button text</label>
        </div>
        <div class="control is-grouped column is-9">
          <p
            class="control is-expanded is-flex"
            style="align-items: center"
          >
            <input
              :class="{'is-danger': errors.has('button text') }"
              name="button text"
              v-model="body.button_text"
              class="input"
              type="text"
              placeholder="Enter button text"
            />
            <span
              v-show="errors.has('button text')"
              class="help is-danger"
            >{{ errors.first('button text') }}</span>
          </p>
        </div>
      </div>

      <div class="control is-horizonetal columns">
        <div class="control-label column is-3 label-create">
          <label class="label">Button link to</label>
        </div>
        <div class="control is-grouped column is-9">
          <p
            class="control is-expanded is-flex"
            style="align-items: center"
          >
            <input
              :class="{'is-danger': errors.has('link to') }"
              name="link to"
              v-model="body.link_to"
              class="input"
              type="text"
              placeholder="Enter link to"
            />
            <span
              v-show="errors.has('link to')"
              class="help is-danger"
            >{{ errors.first('link to') }}</span>
          </p>
        </div>
      </div>

      <div class="control is-horizontal columns">
        <div class="control-label column is-3 label-create">
          <label class="label"></label>
        </div>
        <div class="control column is-9">
          <save-button
            :loading="isSaving"
            @click="save"
          />
          <a
            @click="cancel"
            class="button is-link"
          >Cancel</a>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import { slider } from "api";
  export default {
    components: {
      'slider-dropzone': () => import('./components/slider-dropzone'),
    },
    props: {
      data: {
        type: Object,
        default () {
          return {};
        }
      },
      isSaving: Boolean
    },
    data () {
      return {
        body: {
          title: this.data.title ? this.data.title : "",
          description: this.data.description ? this.data.description : "",
          image: this.data.image ? this.data.image : "",
          mobile_image: this.data.mobile_image ? this.data.mobile_image : "",
          link_to: this.data.link_to ? this.data.link_to : "",
          redirect_url: this.data.redirect_url ? this.data.redirect_url : "",
          button_text: this.data.button_text ? this.data.button_text : null
        },
        galleries: [],
        mobileGalleries: [],
        isLoading: false,
        requiredImage: false,
      };
    },
    mounted () {
    },
    methods: {
      onGallery (data) {
        this.galleries = data;
      },
      onMobileGallery (data) {
        this.mobileGalleries = data;
      },
      setFeaturedImage (img) {
        this.body.image = img;
      },
      setFeaturedMobileImage (img) {
        this.body.mobile_image = img;
      },
      cancel () {
        this.$emit("cancel");
      },
      save () {
        this.requiredImage = !this.galleries || this.galleries.length === 0 ? true : false;
        this.$validator.validateAll().then(result => {
         if (result && !this.requiredImage) {
            let dataSent = { ...this.body };
            dataSent.image = this.galleries[0];

           if (this.mobileGalleries.length > 0) {
             dataSent.mobile_image = this.mobileGalleries[0];
           } else {
             dataSent.mobile_image = "";
           }

            this.$emit("save", dataSent);
          }
        });
      },
      find () {
        let loader = this.$loading.show();
        slider.getSlider(this.$route.params.id).then(res => {
          if (res.data.success === true) {
            this.body = res.data.data;

            if (this.body.image) {
              this.galleries = [];
              this.galleries.push(this.body.image);
            }

            if (this.body.mobile_image) {
              this.mobileGalleries = [];
              this.mobileGalleries.push(this.body.mobile_image);
            }

            loader.hide();
          }
        }).catch(err => {
          if (err.response && err.response.status == '404') {
            this.$router.replace({ path: '/404' })
          }
          loader.hide();
        });
      },
    },
    created () {
      if (this.$route.params.id) {
        this.find()
      }
    },

  };
</script>

<style scoped>
</style>
